var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#A2ADB6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1053 17.2632C13.1053 18.659 13.6598 19.9977 14.6468 20.9848C15.6338 21.9718 16.9725 22.5263 18.3684 22.5263C19.7643 22.5263 21.103 21.9718 22.09 20.9848C23.0771 19.9977 23.6316 18.659 23.6316 17.2632C23.6316 15.8673 23.0771 14.5286 22.09 13.5415C21.103 12.5545 19.7643 12 18.3684 12C16.9725 12 15.6338 12.5545 14.6468 13.5415C13.6598 14.5286 13.1053 15.8673 13.1053 17.2632Z",
    fill: "#0059A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30.9474V28.8421C11 27.7254 11.5175 26.6544 12.4388 25.8648C13.36 25.0752 14.6095 24.6316 15.9123 24.6316H20.8246C22.1274 24.6316 23.3769 25.0752 24.2981 25.8648C25.2193 26.6544 25.7369 27.7254 25.7369 28.8421V30.9474",
    stroke: "#0059A7",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7368 13.1895C26.6425 13.4214 27.4453 13.9481 28.0186 14.6866C28.5918 15.4252 28.903 16.3335 28.903 17.2684C28.903 18.2033 28.5918 19.1117 28.0186 19.8502C27.4453 20.5887 26.6425 21.1155 25.7368 21.3474",
    stroke: "#0059A7",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30.9474V28.8421C30.9947 27.9128 30.682 27.0114 30.1108 26.2783C29.5396 25.5453 28.7419 25.0218 27.8421 24.7895",
    stroke: "#0059A7",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1664e4024f5b56e8fc750cb72da94aaf.svg";
export { ForwardRef as ReactComponent };